import React from 'react';
import { motion } from 'framer-motion';
import { Container } from '../ui/Container';
import { Button } from '../ui/Button';
import { ArrowRight, Calendar, Clock, FileCheck, Shield } from 'lucide-react';
export function MidPageCTA() {
  return <section className="relative overflow-hidden bg-dashboard-surface py-20 border-y border-dashboard-border" data-id="element-175">
      <Container data-id="element-176">
        <motion.div className="max-w-4xl mx-auto" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-177">
          <div className="text-center mb-10" data-id="element-178">
            <h2 className="text-3xl font-black tracking-tight text-dashboard-text sm:text-4xl mb-4" data-id="element-179">
              See Exactly How We'd{' '}
              <span className="text-tech-blue" data-id="element-180">Fix Your Systems</span>
            </h2>
            <p className="text-lg text-dashboard-muted leading-relaxed max-w-2xl mx-auto" data-id="element-181">
              Book a 30-minute discovery call. We'll map your biggest
              bottlenecks and show you the exact ROI you can expect.
            </p>
          </div>

          {/* Risk reversal */}
          <div className="bg-tech-green/5 rounded-lg p-6 border border-tech-green/20 mb-10 max-w-md mx-auto" data-id="element-182">
            <div className="flex items-center gap-3" data-id="element-183">
              <Shield className="w-6 h-6 text-tech-green flex-shrink-0" data-id="element-184" />
              <div data-id="element-185">
                <p className="text-sm font-bold text-tech-green mb-1" data-id="element-186">
                  Zero Risk Consultation
                </p>
                <p className="text-xs text-dashboard-muted" data-id="element-187">
                  No obligation. No sales pressure. Just honest engineering
                  talk.
                </p>
              </div>
            </div>
          </div>

          <div className="flex justify-center mb-12" data-id="element-188">
            <Button variant="cta" size="xl" className="group" data-id="element-189">
              Book a Discovery Call
              <ArrowRight className="ml-2 h-5 w-5 transition-transform group-hover:translate-x-1" data-id="element-190" />
            </Button>
          </div>

          {/* Process timeline */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-191">
            {[{
            icon: Calendar,
            label: 'Pick a Time',
            desc: 'Choose a slot that works for you',
            step: 1
          }, {
            icon: Clock,
            label: '30-Min Call',
            desc: 'We discuss your systems and pain points',
            step: 2
          }, {
            icon: FileCheck,
            label: 'Get Your Roadmap',
            desc: 'Receive a custom fix plan with ROI estimate',
            step: 3
          }].map((item, index) => <motion.div key={index} className="bg-dashboard-bg rounded-lg p-6 border border-dashboard-border relative" initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1,
            duration: 0.5
          }} data-id="element-192">
                <div className="absolute -top-3 -left-3 w-8 h-8 rounded-full bg-tech-blue border-2 border-dashboard-surface flex items-center justify-center" data-id="element-193">
                  <span className="text-sm font-bold text-white" data-id="element-194">
                    {item.step}
                  </span>
                </div>

                <div className="flex flex-col items-center text-center pt-2" data-id="element-195">
                  <div className="w-12 h-12 rounded-lg bg-tech-blue/10 border border-tech-blue/20 flex items-center justify-center mb-4" data-id="element-196">
                    <item.icon className="w-6 h-6 text-tech-blue" data-id="element-197" />
                  </div>
                  <div className="text-sm font-bold text-dashboard-text mb-2" data-id="element-198">
                    {item.label}
                  </div>
                  <div className="text-xs text-dashboard-muted" data-id="element-199">
                    {item.desc}
                  </div>
                </div>
              </motion.div>)}
          </div>
        </motion.div>
      </Container>
    </section>;
}